import { ConfigurationValuableConceptSampleType } from '@/modules/configurationModule/detail/automation/valuable-concepts/services/configuration-valuable-concepts.dto'
import { CommonMostLikelyMorphologicCodeResponse } from '@/api/services/common/most-likely-morphologic-code/common-most-likely-morphologic-code.dto'
import { CommonProcedureResponse } from '@/api/services/common/procedure/common-procedure.dto'
import { CommonTopographicCodeResponse } from '@/api/services/common/topographic-code/common-topographic-code.dto'
import { Nullable } from '@/shared/types/app.types'

export interface LocalAutomationValuableConceptsModalBasicFormState {
    sampleType: Nullable<ConfigurationValuableConceptSampleType>
    topographicCode: Nullable<CommonTopographicCodeResponse>
    procedure: Nullable<CommonProcedureResponse>
    mostLikelyMorphologicCode: Nullable<CommonMostLikelyMorphologicCodeResponse>
}
export const initialLocalAutomationValuableConceptsModalBasicFormState =
    (): LocalAutomationValuableConceptsModalBasicFormState => ({
        sampleType: null,
        mostLikelyMorphologicCode: null,
        procedure: null,
        topographicCode: null
    })
